module.exports = __webpack_public_path__ + "static/media/metricpopup_logo_familytvnetwork.747fb30f.png";